import { CompatiblePluginEventType } from "roosterjs";
/**
 * Rooster plugin that limits the number of characters in the editor
 */ export class RoosterContentLimitPlugin {
    /**
     * Set the max content length for the editor
     * @param newMaxLength The new max length value
     */ setMaxLength(newMaxLength) {
        this.maxLength = newMaxLength;
    }
    /**
     * Gets the name of the plugin
     */ getName() {
        return "RoosterContentLimitPlugin";
    }
    /**
     * Plugin initialize lifecycle hook
     */ initialize(editor) {
        this.editorRef = editor;
    }
    /**
     * Plugin dispose lifecycle hook
     */ dispose() {
        this.editorRef = null;
        this.maxLength = null;
    }
    /**
     * Plugin event hook
     */ onPluginEvent(event) {
        switch(event.eventType){
            case CompatiblePluginEventType.BeforePaste:
                this.handleBeforePasteEvent(event);
                break;
            case CompatiblePluginEventType.KeyPress:
                this.handleKeyPressEvent(event);
                break;
            default:
                break;
        }
    }
    /**
     * Handle before paste event to make sure that the new length won't be more than the max
     * @param event The before paste event
     */ handleBeforePasteEvent(event) {
        if (this.maxLength == null || this.editorRef == null) {
            return;
        }
        const currentContentLength = this.editorRef.getContent().length || 0;
        let clipBoardDataLength = 0;
        // ClipboardData in BeforePasteEvent includes plain text data and/or html data
        // First check if clipboard data includes html data, if not, check if it contains plain text data
        if (event.clipboardData.html) {
            clipBoardDataLength = event.clipboardData.html.length;
        } else {
            if (event.clipboardData.text) {
                clipBoardDataLength = event.clipboardData.text.length;
            }
        }
        // If clipboard data length + current content length is bigger than max length limit, clear paste content
        // Bug # 7943594 - over length content handling (consider options including trimming)
        if (clipBoardDataLength + currentContentLength > this.maxLength) {
            // Remove child nodes from the root node to clear paste content
            while(event.fragment?.firstChild){
                event.fragment.removeChild(event.fragment.firstChild);
            }
        }
    }
    /**
     * Handle keypress event to make sure that the new length won't be more than the max
     * @param event The plugin keypress event
     */ handleKeyPressEvent(event) {
        if (this.maxLength == null || this.editorRef == null) {
            return;
        }
        const currentContentLength = this.editorRef?.getContent()?.length || 0;
        if (currentContentLength >= this.maxLength) {
            // Call preventDefault so the change isn't committed to the editor
            event.rawEvent.preventDefault();
        }
    }
    constructor(maxLength){
        this.editorRef = null;
        this.maxLength = null;
        this.maxLength = maxLength;
    }
}
